import { Type } from '@warp-drive/core-types/symbols';
import Model, { attr, hasMany } from '@ember-data/model';
import type PslfFieldModel from './pslf-field';
import type PslfFormModel from './pslf-form';
import type PslfAssetModel from './pslf-asset.ts';

const personalInfoKeys = [
  'borrowerName',
  'borrowerBirthDate',
  'ssn',
  'borrowerEmail',
  'borrowerPrimaryPhone',
] as const;

const addressKeys = [
  'borrowerAddress',
  'borrowerApartment',
  'borrowerCity',
  'borrowerState',
  'borrowerZip',
] as const;

const employerFieldsKeys = [
  'borrowerPriorEmployerClosed',
  'borrowerWantsForbearance',
  'employerContactEmail',
  'employerFein',
  'employerName',
  'employerWebsite',
  'employmentStartDate',
  'employmentEndDate',
  'employmentHours',
  'employerContactName',
  'employerContactPhoneNumber',
  'employerContactTitle',
  // 'employmentContinues',
  // 'employmentFullTime',
  // 'employmentPartTime',
] as const;

interface BorrowerFormFields {
  personalInfo: PslfFieldModel[];
  address: PslfFieldModel[];
  employerFields: PslfFieldModel[];
}

export default class PslfTemplateModel extends Model {
  @attr declare name: string;

  @hasMany('pslf-form', { async: false, inverse: 'pslfTemplate' })
  declare pslfForms: PslfFormModel[];
  @hasMany('pslf-field', { async: false, inverse: 'pslfTemplate' })
  declare pslfFields: PslfFieldModel[];
  @hasMany('pslf-asset', { async: false, inverse: 'pslfTemplates' })
  declare pslfAssets: PslfAssetModel[];

  get borrowerFormFields(): BorrowerFormFields {
    const fieldsByKey = new Map(this.pslfFields.map((f) => [f.key, f]));

    const orderBy = (keys: readonly string[]) =>
      keys.map((key) => fieldsByKey.get(key)).filter(Boolean) as PslfFieldModel[];

    return {
      personalInfo: orderBy(personalInfoKeys),
      address: orderBy(addressKeys),
      employerFields: orderBy(employerFieldsKeys),
    };
  }

  get pdfUrl() {
    return this.pslfAssets[0]?.signedUrl || '';
  }

  [Type] = 'pslf-template' as const;
}
